import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa0a71a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"padding":"10px 0"},
  key: "1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "富文本", -1))
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "item-container rich-show-container",
    style: _normalizeStyle({
    ..._ctx.modelValue.style,
    paddingLeft: _ctx.modelValue.gap + 'px',
    paddingRight: _ctx.modelValue.gap + 'px',
  })
  }, [
    (_ctx.empty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode("点此编辑"),
          _hoisted_2,
          _createTextVNode("内容")
        ]))
      : (_openBlock(), _createElementBlock("div", {
          innerHTML: _ctx.modelValue.content,
          key: "2"
        }, null, 8, _hoisted_3))
  ], 4))
}